import { render, staticRenderFns } from "./addcustomer.vue?vue&type=template&id=1c1e42f9&scoped=true&"
import script from "./addcustomer.vue?vue&type=script&lang=js&"
export * from "./addcustomer.vue?vue&type=script&lang=js&"
import style0 from "./addcustomer.vue?vue&type=style&index=0&id=1c1e42f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e42f9",
  null
  
)

export default component.exports